module.exports = __webpack_public_path__ + "static/media/JOURNEY-THROUGH-NIGHT-4.e8ec21ec.jpg";